import React from 'react';
import ReferralIcon from 'shared/img/referral.svg';
import FafsaIcon from 'shared/img/checkmark.svg';
import DegreeProgressIcon from 'shared/img/graduation-cap.svg';
import CollegeSuccessIcon from 'shared/img/portfolio/college-success.svg';
import PortfolioIcon from 'shared/portfolio/components/portfolio-icon/portfolio-icon';

const ICON_SIZE = 24;

export const COLLEGE_PROFILE_SCHOLARSHIP_DATA = {
  academic: {
    title: 'Courses',
    icon: <PortfolioIcon size={ICON_SIZE} type="courses" />,
  },
  degreeProgress: {
    title: 'Degree Progress',
    icon: <DegreeProgressIcon width={ICON_SIZE} height={ICON_SIZE} />,
  },
  volunteer: {
    title: 'Community Service',
    icon: <PortfolioIcon type="communityService" size={ICON_SIZE} />,
  },
  activity: {
    title: 'Extracurriculars',
    icon: <PortfolioIcon type="activities" size={ICON_SIZE} />,
  },
  sport: {
    title: 'Sports',
    icon: <PortfolioIcon type="activities" size={ICON_SIZE} />,
  },
  honor: {
    title: 'Honors and Awards',
    icon: <PortfolioIcon type="honorAwards" size={ICON_SIZE} />,
  },
  scores: {
    title: 'Test Scores',
    icon: <PortfolioIcon type="testScores" size={ICON_SIZE} />,
  },
  visits: {
    title: 'College Readiness',
    icon: <PortfolioIcon type="events" size={ICON_SIZE} />,
  },
  referral: {
    title: 'Referral Scholarships',
    icon: <ReferralIcon width={ICON_SIZE} height={ICON_SIZE} />,
  },
  work: {
    title: 'Work Experience',
    icon: <PortfolioIcon type="workExperiences" size={ICON_SIZE} />,
  },
  fafsa: {
    title: 'FAFSA',
    icon: <FafsaIcon width={ICON_SIZE} height={ICON_SIZE} />,
  },
  multimedia: {
    title: 'Multimedia',
    icon: <PortfolioIcon size={ICON_SIZE} type="multimedia" />,
  },
  collegeSuccess: {
    title: 'College Success',
    icon: <CollegeSuccessIcon width={ICON_SIZE} height={ICON_SIZE} />,
  },
};

export const SCHOLARSHIP_TYPE_MAP = {
  ApScoreScholarship: 'scores',
  AssociateDegreeProgressScholarship: 'degreeProgress',
  CampusVisitScholarship: 'visits',
  CertificationScholarship: 'academic',
  ChallengingClassScholarship: 'academic',
  ClaimedAccountScholarship: 'collegeSuccess',
  College101EventScholarship: 'visits',
  CollegeFairScholarship: 'visits',
  CollegeReceptionScholarship: 'visits',
  CollegeReplacementScholarship: 'hidden',
  CommunityServiceScholarship: 'volunteer',
  CourseGradeScholarship: 'academic',
  CourseSubjectScholarship: 'academic',
  CustomCollegeEventScholarship: 'visits',
  DiscoverGcuEventScholarship: 'visits',
  DiscoveryDaysEventScholarship: 'visits',
  ExtracurricularActivityScholarship: 'activity',
  FafsaScholarship: 'fafsa',
  ForeignLanguageScholarship: 'academic',
  FullCourseLoadScholarship: 'academic',
  GTechArchitectureEventScholarship: 'visits',
  GenericScholarship: 'hidden',
  HonorAwardScholarship: 'honor',
  LeadershipScholarship: 'activity',
  MultimediaScholarship: 'multimedia',
  OtherTestScholarship: 'scores',
  OverallGpaScholarship: 'academic',
  PerfectAttendanceScholarship: 'academic',
  PsatPreActScholarship: 'scores',
  PsatPreActScoreScholarshipBase: 'scores',
  ReferralScholarship: 'referral',
  RegentScholarship: 'scores',
  SatActScholarship: 'scores',
  SatActScoreScholarshipBase: 'scores',
  SportsActivityScholarship: 'sport',
  SummerProgramScholarship: 'visits',
  SurveyScholarship: 'collegeSuccess',
  Teacher101EventScholarship: 'visits',
  TimeSensitiveItemScholarship: 'collegeSuccess',
  WorkExperienceScholarship: 'work',
  PsatPreActScoreScholarship: 'scores',
  PsatPreActScoreScholarship2: 'scores',
  SatActScoreScholarship: 'scores',
};

// Statuses where the scholarships and requirements
// tabs are hidden.
export const HIDE_STATUSES = [
  'scholarships_not_yet_available',
  'limited_scholarships',
  'deadline_passed',
  'us_citizenship_required',
  'complete_profile',
  'us_citizens_only',
];
